<p class="font-semibold">
  {{ '#APPLICATION.OFFLINE.STORAGE.SETTINGS.RESET.LABEL' | translate }}
</p>
<p class="text-sm color-light mt-1">
  {{ '#APPLICATION.OFFLINE.STORAGE.SETTINGS.RESET.INFO' | translate }}
</p>
<button class="soft-button primary mt-4" (click)="clearCache()">
  {{ '#APPLICATION.OFFLINE.STORAGE.SETTINGS.RESET.DELETE' | translate }}
</button>
